import { useState } from "react";
import { api, apiError } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Loader2, Save } from "lucide-react";

// Premio minimo lordo Agenzia per prodotto: i Partner non scendono sotto; chi ha la deroga sì.
export const PremioMinimoBox = ({ product, onSaved }) => {
  const [v, setV] = useState(product.premio_minimo_agenzia ?? "");
  const [busy, setBusy] = useState(false);
  const salva = async () => {
    setBusy(true);
    try {
      await api.put(`/admin/products/${product.code}/premio-minimo`, { valore: v === "" ? null : Number(v) });
      toast.success(v === "" ? "Premio minimo rimosso" : "Premio minimo salvato"); onSaved?.();
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };
  return (
    <div className="mt-4 flex flex-wrap items-end gap-3 rounded-lg border border-forest/15 bg-sage/30 p-3" data-testid={`premio-minimo-${product.code}`}>
      <div className="space-y-1">
        <span className="text-xs font-medium uppercase tracking-wide text-forest/70">Premio minimo lordo Agenzia (€)</span>
        <Input type="number" min={0} step="1" value={v} onChange={(e) => setV(e.target.value)} placeholder="Nessuno" className="h-8 w-36 bg-white" data-testid={`premio-minimo-input-${product.code}`} />
      </div>
      <Button size="sm" onClick={salva} disabled={busy} className="h-8 gap-1 bg-forest hover:bg-forest-hover" data-testid={`premio-minimo-save-${product.code}`}>{busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Save className="h-3.5 w-3.5" />}Salva</Button>
      <p className="basis-full text-[11px] text-muted-foreground">Se il premio calcolato è più basso, ai Partner viene applicato questo minimo. Admin e utenti con "Può scendere sotto il premio minimo" possono restare sotto senza autorizzazione.</p>
    </div>
  );
};
